import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { Router } from '@angular/router';
import { RewardService } from 'src/app/core/api/reward/reward.service';

@Component({
  selector: 'app-point-balance-list',
  templateUrl: './point-balance-list.component.html',
  styleUrls: ['./point-balance-list.component.scss'],
})

/**
 * Display main components of point balance list page
 */
export class PointBalanceListComponent implements OnInit {
  @Input() business?: BusinessResponseDTO;
  @Input() isMobile = true;

  pointBalanceList: any = [];

  labels = {
    pointBalanceLabel: 'point-balance-list',
  };

  language = '';

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    public readonly rewardService: RewardService,
    private router: Router
  ) {}

  /**
   * ngOnInit()
   */
  ngOnInit(): void {
    this.language = this.translationService.getActiveLang();
    this.translationService.translateObject(this.labels);

    this.getPointSummaries();
  }

  /**
   * Redirect to the point balance
   * @param {number} family
   */
  navigateToPointsDetail(family: number) {
    this.router.navigate(['point-balance'], {
      queryParams: {
        familyId: family,
      },
    });
  }

  /**
   * Get summary of points for all families
   */
  getPointSummaries() {
    this.rewardService
      .getPointSummaryForAllFamilies()
      .subscribe((pointSummaryList) => {
        this.pointBalanceList = pointSummaryList;
      });
  }

  /**
   * Find the Business Level from business associated to an specific series
   * @param {number} family
   * @return {string} the Business Level found
   */
  findBusinessLevelBySeries(family: number): string {
    const businessLevels = this.business?.businessLevels;

    for (const level of businessLevels!) {
      if (level.familyPk === family) {
        return level.description;
      }
    }

    return '';
  }
}
